import { ArrowBack, Close } from '@mui/icons-material'
import { Typography } from '@renderer-ui-library/mui'
import { useBlockGlobalScrolling } from '@renderer-ui-library/mui/utils/globalScrolling/useBlockGlobalScrolling'
import classNames from 'classnames'
import { SyntheticEvent } from 'react'
import styles from './mobileOverlay.module.scss'

export type Props = {
  open: boolean
  title?: string
  hideTitle?: boolean
  titleContent?: React.ReactNode
  fullHeight?: boolean
  animationDirection?: 'left' | 'bottom'
  onCloseClick: (e: SyntheticEvent) => void
  onBackButtonClick?: (() => void) | null
  children?: React.ReactNode
}

export const MobileOverlay: React.FC<Props> = (props) => {
  useBlockGlobalScrolling(props.open)

  return (
    <>
      <div
        className={classNames(styles.shim, { [styles.show]: props.open })}
        onClick={props.onCloseClick}
      />
      <div
        className={classNames(styles.overlay, {
          [styles.open]: props.open,
          [styles.fullHeight]: props.fullHeight,
          [styles.left]: props.animationDirection === 'left',
        })}
      >
        {!props.hideTitle && (
          <div className={styles.title}>
            {props.onBackButtonClick && (
              <div className={styles.back}>
                <ArrowBack
                  fontSize='inherit'
                  color='primary'
                  onClick={props.onBackButtonClick}
                />
              </div>
            )}
            {props.titleContent ? (
              props.titleContent
            ) : props.title ? (
              <Typography variant='h5'>{props.title}</Typography>
            ) : null}
            <div className={styles.close}>
              <Close
                fontSize='inherit'
                color='primary'
                onClick={props.onCloseClick}
              />
            </div>
          </div>
        )}
        <div className={styles.content}>{props.children}</div>
      </div>
    </>
  )
}
